<template>
    <div class="nc-loading-overlay">
        <div class="nc-loading-content">
            <div class="nc-loading-spinner">
                <svg class="nc-loading-ring" viewBox="0 0 50 50">
                    <circle class="nc-loading-ring__track" cx="25" cy="25" r="20" fill="none" stroke-width="3" />
                    <circle class="nc-loading-ring__fill" cx="25" cy="25" r="20" fill="none" stroke-width="3" stroke-linecap="round" />
                </svg>
                <div class="nc-loading-icon">
                    <mdicon name="shield-check" size="20" />
                </div>
            </div>
            <p class="nc-loading-text">{{ message }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "novacheck-loading",
    props: {
        message: {
            type: String,
            default: 'Een moment geduld...'
        },
        color: {
            type: String,
            default: 'primary'
        }
    }
}
</script>

<style scoped>
.nc-loading-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    animation: nc-fade-in 0.3s ease;
}

.nc-loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.nc-loading-spinner {
    position: relative;
    width: 64px;
    height: 64px;
}

.nc-loading-ring {
    width: 100%;
    height: 100%;
    animation: nc-spin 1.4s linear infinite;
}

.nc-loading-ring__track {
    stroke: color-mix(in srgb, var(--nc-color-primary) 12%, transparent);
}

.nc-loading-ring__fill {
    stroke: var(--nc-color-primary);
    stroke-dasharray: 80, 200;
    stroke-dashoffset: 0;
    animation: nc-dash 1.4s ease-in-out infinite;
}

.nc-loading-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--nc-color-primary);
    opacity: 0.6;
    animation: nc-breathe 2s ease-in-out infinite;
}

.nc-loading-text {
    font-size: var(--nc-font-size-sm);
    font-weight: var(--nc-font-weight-semibold);
    color: var(--nc-color-primary);
    margin: 0;
    letter-spacing: -0.01em;
}

@keyframes nc-spin {
    100% { transform: rotate(360deg); }
}

@keyframes nc-dash {
    0% { stroke-dasharray: 1, 200; stroke-dashoffset: 0; }
    50% { stroke-dasharray: 80, 200; stroke-dashoffset: -30; }
    100% { stroke-dasharray: 80, 200; stroke-dashoffset: -125; }
}

@keyframes nc-breathe {
    0%, 100% { opacity: 0.5; transform: translate(-50%, -50%) scale(1); }
    50% { opacity: 0.8; transform: translate(-50%, -50%) scale(1.05); }
}

@keyframes nc-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
}
</style>
